import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';

@Component({
  standalone: false,
  template: ''
})
export class LinktoComponent implements OnInit {

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activeRoute.queryParams.subscribe(params => {
      this.redirect(params);
    });
  }

  private redirect(params: Params) {

    const reservationId: string = params.bookingid;

    switch (params.iceaction) {

      case 'cancel':

        if (reservationId) {
          this.router.navigate([`/cancellation/${reservationId}`]);
        } else {
          this.router.navigate(['/']);
        }

        break;

      case 'confirmation':
      case 'receipt':

        if (reservationId) {
          this.router.navigate([`/confirmation/${reservationId}`]);
        } else {
          this.router.navigate(['/']);
        }

        break;

      case 'search':

        const qParams = { ...params };
        delete qParams.iceaction;
        delete qParams.partnerid;
        delete qParams.nameid;
        delete qParams.agentid;
        delete qParams.memberid;
        delete qParams.thirdpartyid;
        delete qParams.thirdpartyguid;
        delete qParams.transactiontype;

        this.router.navigate(['/cars'], { queryParams: qParams });
        break;

      case 'farerules':
        if (reservationId) {
          this.router.navigate([`/fare-rules/${reservationId}`]);
        } else {
          this.router.navigate(['/']);
        }
        break;

      default:
        this.router.navigate(['/']);
        break;

    }

  }

}
